export default __webpack_public_path__ + "static/media/magicsnacks@2x.5bd47969.jpg";